import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-walking-farm-help',
  standalone: false,
  templateUrl: './help.component.html'
})
export class HelpPageComponent {
  private activatedRoute = inject(ActivatedRoute);

  defaultBackHref: string | undefined;
  defaultHref: string;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'];
    this.defaultHref = [this.defaultBackHref ?? '', 'walking-farm'].join('/');
  }
}
